import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {REDIRECT_KEY} from '../../../constants';
import {updateSpinnerLoadingAction} from '../../../store/actions/spinner.actions';
import {fetchLoggedInUserAction} from '../../../store/actions/auth.actions';
import {AuthService, handleExternalAuthCallback} from '../../../service/externalAuth.service';

function Callback(): JSX.Element {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const {serviceName} = useParams();

    useEffect(() => {
        dispatch(updateSpinnerLoadingAction(true));

        const handleCallback = async (): Promise<void> => {
            try {
                const redirectPath = localStorage.getItem(REDIRECT_KEY);
                const query = new URLSearchParams(location.search);
                const code = query.get('code') as string;
                await handleExternalAuthCallback(code, serviceName as AuthService);
                dispatch(fetchLoggedInUserAction());
                navigate(redirectPath ?? '/');
            } catch (error) {
                navigate('/login');
            }
        };

        handleCallback();

        return () => {
            dispatch(updateSpinnerLoadingAction(false));
        };
    }, [dispatch, location.search, navigate, serviceName]);

    return <div />;
}

export default Callback;
